"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassTransformers = void 0;
const class_transformer_1 = require("class-transformer");
const lodash_1 = require("lodash");
const redactor_1 = require("../redactor");
const date_transformers_1 = require("./date-transformers");
var ClassTransformers;
(function (ClassTransformers) {
    // =============================================================================
    // Array class transformers
    // =============================================================================
    function ArrayClassTransformer(transformFn) {
        return ({ value, obj, type }) => {
            return (0, lodash_1.map)(value, (valueItem) => transformFn({ value: valueItem, obj, type }));
        };
    }
    ClassTransformers.ArrayClassTransformer = ArrayClassTransformer;
    // =============================================================================
    // JS Joda class transformers
    // =============================================================================
    function LocalDateClassTransformer(params) {
        switch (params.type) {
            case class_transformer_1.TransformationType.CLASS_TO_PLAIN:
                return (0, date_transformers_1.localDateToDto)(params.value);
            case class_transformer_1.TransformationType.PLAIN_TO_CLASS:
                return (0, date_transformers_1.localDateFromDto)(params.value);
            default:
                return params.value;
        }
    }
    ClassTransformers.LocalDateClassTransformer = LocalDateClassTransformer;
    function LocalTimeClassTransformer(params) {
        switch (params.type) {
            case class_transformer_1.TransformationType.CLASS_TO_PLAIN:
                return (0, date_transformers_1.localTimeToDto)(params.value);
            case class_transformer_1.TransformationType.PLAIN_TO_CLASS:
                return (0, date_transformers_1.localTimeFromDto)(params.value);
            default:
                return params.value;
        }
    }
    ClassTransformers.LocalTimeClassTransformer = LocalTimeClassTransformer;
    function LocalDateTimeClassTransformer(params) {
        switch (params.type) {
            case class_transformer_1.TransformationType.CLASS_TO_PLAIN:
                return (0, date_transformers_1.localDateTimeToDto)(params.value);
            case class_transformer_1.TransformationType.PLAIN_TO_CLASS:
                return (0, date_transformers_1.localDateTimeFromDto)(params.value);
            default:
                return params.value;
        }
    }
    ClassTransformers.LocalDateTimeClassTransformer = LocalDateTimeClassTransformer;
    function ZonedDateTimeClassTransformer(params) {
        switch (params.type) {
            case class_transformer_1.TransformationType.CLASS_TO_PLAIN:
                return (0, date_transformers_1.zonedDateTimeToDto)(params.value);
            case class_transformer_1.TransformationType.PLAIN_TO_CLASS:
                return (0, date_transformers_1.zonedDateTimeFromDto)(params.value);
            default:
                return params.value;
        }
    }
    ClassTransformers.ZonedDateTimeClassTransformer = ZonedDateTimeClassTransformer;
    // =========================================================================
    // SAFE TRANSFORMERS
    // =========================================================================
    /**
     * Similar to ZonedDateTimeClassTransformer, but catches and ignores any errors when converting,
     * and returns the original value.
     *
     * This is useful when some dates are in a bad format, and you want to fallback to the original.
     */
    function SafeZonedDateTimeClassTransformer(params) {
        try {
            return ZonedDateTimeClassTransformer(params);
        }
        catch (e) {
            return params.value;
        }
    }
    ClassTransformers.SafeZonedDateTimeClassTransformer = SafeZonedDateTimeClassTransformer;
    function SafeLocalDateClassTransformer(params) {
        try {
            return LocalDateClassTransformer(params);
        }
        catch (e) {
            return params.value;
        }
    }
    ClassTransformers.SafeLocalDateClassTransformer = SafeLocalDateClassTransformer;
    function SafeLocalTimeClassTransformer(params) {
        try {
            return LocalTimeClassTransformer(params);
        }
        catch (e) {
            return params.value;
        }
    }
    ClassTransformers.SafeLocalTimeClassTransformer = SafeLocalTimeClassTransformer;
    function SafeLocalDateTimeClassTransformer(params) {
        try {
            return LocalDateTimeClassTransformer(params);
        }
        catch (e) {
            return params.value;
        }
    }
    ClassTransformers.SafeLocalDateTimeClassTransformer = SafeLocalDateTimeClassTransformer;
    // =============================================================================
    // Date class transformers
    // =============================================================================
    function DateClassTransformer(params) {
        if (!params.value) {
            return params.value;
        }
        switch (params.type) {
            case class_transformer_1.TransformationType.CLASS_TO_PLAIN:
                return params.value.toISOString();
            case class_transformer_1.TransformationType.PLAIN_TO_CLASS:
                return new Date(params.value);
            default:
                return params.value;
        }
    }
    ClassTransformers.DateClassTransformer = DateClassTransformer;
    // =============================================================================
    // String class transformers
    // =============================================================================
    function UinfinClassTransformer(params) {
        if (!params.value) {
            return params.value;
        }
        if (params.type === class_transformer_1.TransformationType.CLASS_TO_PLAIN) {
            return redactor_1.Redactor.UINFIN_REDACTOR.redactValue(params.value);
        }
        else {
            return params.value;
        }
    }
    ClassTransformers.UinfinClassTransformer = UinfinClassTransformer;
    function StringToArrayClassTransformer(delimiter = ",") {
        return (params) => {
            const { type, value } = params;
            switch (type) {
                case class_transformer_1.TransformationType.PLAIN_TO_CLASS:
                    return value.split(delimiter);
                case class_transformer_1.TransformationType.CLASS_TO_PLAIN:
                    return value.join(delimiter);
                default:
                    return value;
            }
        };
    }
    ClassTransformers.StringToArrayClassTransformer = StringToArrayClassTransformer;
    function ToNumber(params) {
        return isNaN(Number(params.value)) ? params.value : Number(params.value);
    }
    ClassTransformers.ToNumber = ToNumber;
    function ToBoolean(params) {
        if (!params.value) {
            return params.value;
        }
        const value = params.value.toLowerCase();
        if (value === "true") {
            return true;
        }
        if (value === "false") {
            return false;
        }
        return params.value;
    }
    ClassTransformers.ToBoolean = ToBoolean;
})(ClassTransformers || (exports.ClassTransformers = ClassTransformers = {}));
//# sourceMappingURL=class-transformers.js.map